const CHECKOUT_BASE = 'https://buy.stripe.com/dRm4gscnr05e7lO3DH6EU00'

// UTM / tracking params we want to forward from the landing page URL to the
// Stripe checkout so attribution is preserved through the sale.
const FORWARD_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'src',
  'fbclid',
  'gclid',
  'ttclid',
]

/**
 * Builds the Stripe checkout URL, forwarding any UTM / tracking parameters
 * present in the current page URL. Because the buttons redirect via
 * window.location.href (not an <a href>), the params are merged manually here
 * so attribution is preserved through to the checkout.
 */
export function buildCheckoutUrl(): string {
  if (typeof window === 'undefined') return CHECKOUT_BASE
  try {
    const current = new URLSearchParams(window.location.search)
    const url = new URL(CHECKOUT_BASE)
    for (const key of FORWARD_PARAMS) {
      const value = current.get(key)
      if (value) url.searchParams.set(key, value)
    }
    return url.toString()
  } catch {
    return CHECKOUT_BASE
  }
}
